import { ServiceScheduleType } from '../../../graphql/graphql';

//DEFINITION OF LABELS AND COLORS FOR DIFFERENT SCHEDULE TYPES
export const EVENT_PRESET: Record<
	ServiceScheduleType,
	{ label: string; eventColor: string }
> = {
	[ServiceScheduleType.Shift]: {
		label: 'base.shift',
		eventColor: '#b6d3fc',
	},
	[ServiceScheduleType.ShiftExtra]: {
		label: 'base.extraService',
		eventColor: '#62a2ff',
	},
	[ServiceScheduleType.OnlineOrder]: {
		label: 'component.workplaceOrderingSettingsCalendar.eventTitle',
		eventColor: '#62a2ff',
	},
	[ServiceScheduleType.OnlineConnect]: {
		label: '',
		eventColor: '',
	},
	[ServiceScheduleType.Default]: {
		label: '',
		eventColor: '',
	},
};
